import { render, staticRenderFns } from "./RecordCard.vue?vue&type=template&id=4878d793&scoped=true&"
import script from "./RecordCard.vue?vue&type=script&lang=ts&"
export * from "./RecordCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecordCard.vue?vue&type=style&index=0&id=4878d793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878d793",
  null
  
)

export default component.exports